import styled from 'styled-components';
import { Label } from 'atoms/Texts';

export const IconWrapper = styled.span`
  width: 20px;
  margin-right: 18px;
`

export const StyledContainer = styled.div`
  height: 42px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  &:hover {
    background-color: ${({ showPointer, theme }) => (showPointer ? theme.mocaThinnerGrey : theme.white)};
    cursor: ${({ showPointer }) => (showPointer ? 'pointer' : 'default')};
  }
`

export const LabelPadded = styled(Label)`
  margin-right: 12px;
`